import { urlService } from "infra/envs";
import axiosInstance from "utils/axiosConfig";
import { useMutationHandler } from "./useMutationHandler";

export const useSetNoteMutation = () =>
    useMutationHandler(({ id, note }) =>
        axiosInstance.post(urlService.LINQ_REQUESTS_LISTING_STORE_NOTE_PATH, {
            linq_request_id: id,
            note,
        }),
    );

export const useSetPhoneCallMutation = () =>
    useMutationHandler(({ id, date }) =>
        axiosInstance.post(
            urlService.LINQ_REQUESTS_LISTING_STORE_PHONE_CALL_PATH,
            {
                linq_request_id: id,
                date,
            },
        ),
    );
